export const appointmentStatusMap: any = {
  scheduled: { label: "Scheduled", variant: "sent" },
  completed: { label: "Completed", variant: "active" },
  cancelled: { label: "Cancelled", variant: "cancelled" },
  rescheduled: { label: "Rescheduled", variant: "pending" },
  no_show: { label: "No Show", variant: "cancelled" },
};
